import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const LockedSteeringWheelFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.1 3.96L20.22 5.06L5.3 19.96L4.2 18.86L5.36 17.7C4 16.14 3.18 14.14 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C14.18 3.18 16.18 3.98 17.74 5.32L19.1 3.96ZM12 6.66C9.4 6.66 7.18 8.64 6.78 11.16H11.9L15.26 7.8C14.36 7.1 13.22 6.66 12 6.66ZM20.82 11.96C20.82 16.76 16.82 20.74 12 20.74C10.52 20.74 9.12 20.36 7.88 19.7L9.02 18.56C9.7 18.88 10.44 19.1 11.2 19.18V16.4L12.8 14.8V19.18C16.12 18.8 18.8 16.1 19.18 12.76H14.84L16.44 11.16H18.04C17.98 10.72 17.88 10.28 17.72 9.88C17.72 9.88 19.78 7.86 19.76 7.84C20.44 9.06 20.82 10.48 20.82 11.96ZM4.82 12.76C4.98 14.2 5.58 15.52 6.46 16.6L10.3 12.76H4.82Z" />
    </SvgIcon>
  );
});
